import React, { Component } from 'react';
import { Link } from 'react-router-dom'

var lodash = require('lodash')

class List extends Component {

  constructor(props) {
    super(props);

    this.state = {
      types: [],
      filterName: '',
    }
  }

  componentWillMount() {
    this.fetchTypes();
  }

  fetchTypes() {
    fetch(localStorage.backoffice_api + '/api/holidays/types', {
      method: 'GET',
      headers: {
        authorization: localStorage.JWT,
      }
    })
        .then((response) => {
          if (!response.ok) {
            throw Error(response.statusText);
          }
          return response.json();
        })
        .then((json) => {
          var types = lodash.sortBy(json, (type) => {
            return [
              type.Libelle,
              type.EstActif ? 0 : 1,
            ];
          })

          this.setState({
            types: types,
          });
        })
        .catch((error) => {
          console.log(error)
        });
  }

  render() {

    return (
        <div className='container-fluid'>
          <div className="row">
            <div className="col">

              <h2>Type d'absences</h2>

              <br />

              <div>
                <Link to='/holidayTypes/create' className='btn btn-light'>
                  <i className="fa fa-plus"></i> Ajouter
                </Link>

                <div className='float-right'>
                  <div className="form-inline" style={{ marginTop: '2px' }}>
                    <div className="input-group">
                      <span className="input-group-addon" id="basic-addon1"><i className='fa fa-filter'></i></span>
                      <input type='search' className='form-control form-control-sm float-right' value={this.state.filterName} onChange={(event) => this.setState({filterName: event.target.value})} placeholder='Filtre par libellé' />
                    </div>
                  </div>
                </div>
              </div>

              <br />

              <table className="table table-striped table-hover table-sm">
                <thead>
                <tr>
                  <th>#</th>
                  <th>Libellé</th>
                  <th>Est actif</th>
                  <th></th>
                </tr>
                </thead>
                <tbody>
                {this.state.types.map((type) => {
                  if (this.state.filterName) {
                    if (type.Libelle.toLowerCase().search(this.state.filterName.toLowerCase()) === -1) {
                      return false;
                    }
                  }

                  return (<tr key={type.IDPeopleHolidayType}>
                    <td>{type.IDPeopleHolidayType}</td>
                    <td>{type.Libelle}</td>
                    <td>
                      {type.EstActif && <i className="fa fa-check"></i>}
                    </td>
                    <td>
                      <Link to={'/holidayTypes/'+type.IDPeopleHolidayType} className='btn btn-primary btn-sm'>
                        <i className="fa fa-pencil"></i>
                      </Link>
                      &nbsp;
                    </td>
                  </tr>)
                })}
                </tbody>
              </table>

            </div>
          </div>
        </div>
    );
  }
}

export default List;
